import { useTwoFactorChallengeFlow } from "../../../application/v2";
import { usesBearerAuth } from "../../../data";
import { UnauthenticatedLayoutV2 } from "../../../ui/layout/v2";
import { TwoFactorPageV2 } from "../../../ui/pages/v2/TwoFactorPage";

export function TwoFactorV2Route() {
  const challenge = useTwoFactorChallengeFlow();

  return (
    <UnauthenticatedLayoutV2>
      <TwoFactorPageV2
        canTrustDevice={!usesBearerAuth()}
        emailCodeSent={challenge.emailCodeSent}
        error={challenge.error}
        isSendingEmailCode={challenge.isSendingEmailCode}
        isSubmitting={challenge.isSubmitting}
        method={challenge.method}
        onMethodChange={challenge.selectMethod}
        onSendEmailCode={challenge.sendEmailCode}
        onSubmit={challenge.verify}
      />
    </UnauthenticatedLayoutV2>
  );
}
